import React, { useEffect, useMemo, useState } from "react";
import "./Invoice.css";
import { BsPlusCircle } from "react-icons/bs";
import { useNavigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { Api, BaseUrl } from "../../../Config/Api";
import { toast } from "react-toastify";
import EditInvoice from "./Component/EditInvoice";
import Rec from "../../../Assets/pay.png";
import NotRec from "../../../Assets/rec.png";
import Sent from "../../../Assets/Send.png";
import NotSent from "../../../Assets/notSend.png";
import Pencile from "../../../Assets/pencil.png";
import Delete from "../../../Assets/Color.png";
import InvoicePic from "../../../Assets/Invoices.png";
import { Table } from "antd";
import MainLayout from "../../../../layouts/MainLayout";
import { getAllInvoiceData } from "../../../../redux/actions/employeeActions";
import { callApi } from "../../../../config/apiCall";
import Loader from "../../../../components/Loader";

const Invoice = () => {
  const [isloading, setLoading] = useState(false);
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails")) || {}
  const [query, setQuery] = useState("");
  const [invoiceData, setInvoiceData] = useState([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [showDeletePopUp, setShowDeletePopUp] = useState({});
  const token = sessionStorage.getItem("authToken");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/admin/billing/invoice/add");
  };
  const getAllinvoice = useSelector((state) => state.employeeData?.allInvoice);
  const isDataLoading = useSelector((state) => state.employeeData?.loading);
  useEffect(() => {
    dispatch(getAllInvoiceData());
  }, []);

  // //console.log("isDataLoading", isDataLoading);


  const handleInputChange = (event) => {
    setQuery(event.target.value);
  };


  const columns = [
    {
      title: "INVOICE#",
      dataIndex: "invoice_no",
      filtering: false,
      width: 150,
      render: (_, data) => (
        <div
          className="invoice-header-hover d-flex align-items-center gap-1"
          onClick={() => downloadInvoice(data)}
        >
          <img
            src={InvoicePic}
            alt="Mail Sent"
            style={{ width: 20, height: 20 }} // Add spacing between image and text
          />
          <p
            style={{
              color: "blue",
              textDecoration: "underline",
              marginLeft: 10,
              margin: 0, // Remove default margin
            }}
          >
            {data?.invoice_no}
          </p>
        </div>
      ),
    },

    {
      title: "DATE",
      dataIndex: "invoice_date",
      width: 150,
    },

    {
      title: "NAME & COMPANY",
      dataIndex: "company_name",
      width: 200,
      render: (_, rowData) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {rowData.customer_name} ({rowData.company_name})
        </span>
      ),
    },
    {
      title: "AMOUNT",
      dataIndex: "total",
      width: 150,
      render: (_, rowData) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {/* {console.log(rowData?.symbol)
          } */}
          {rowData?.symbol ? rowData?.symbol : "₹"}
          {parseInt(rowData.total).toFixed(2)}
        </span>
      ),
    },

    {
      title: "INVOICE STATUS",
      dataIndex: "invoice_status",
      width: 150,
      filtering: false,
      render: (rowData) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            gap: "5px", // Adds spacing between image and text
          }}
        >
         {/* { //console.log(rowData?.invoice_status ,rowData)} */}
          
          {rowData == "MailSent" ? (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <img
                src={Sent}
                alt="Mail Sent"
                style={{ width: 20, height: 20 }}
              />
              <span style={{ verticalAlign: "middle" }}>Send</span>
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <img
                src={NotSent}
                alt="No Payment"
                style={{ width: 20, height: 20 }}
              />
              <span style={{ verticalAlign: "middle", textAlign: "center" }}>
                Draft
              </span>
            </div>
          )}
        </div>
      ),
    },

    {
      title: "PAYMENT RECEIVED",
      dataIndex: "payment_received",
      filtering: false,
      width: 200,
      render: (_, rowData) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          {rowData?.payment_receiveed <= 0 ||
            rowData?.payment_receiveed == null ? (
            <img
              src={NotRec}
              alt="Payment Received"
              style={{ width: 25, height: 25 }}
            />
          ) : (
            <img src={Rec} alt="No Payment" style={{ width: 25, height: 25 }} />
          )}
        </div>
      ),
    },

    {
      title: "STATUS",
      // dataIndex: "mobile",
      filtering: false,
      width: 150,
      render: (rowData) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 20,
            background:
              rowData?.total === rowData?.payment_receiveed ? "#E5F7E8" : "#B1D7FF",
            padding: "5px 10px",
          }}
        >

          {
            console.log("rowData" ,rowData )
            
          }
          <div
            style={{
              background:
                rowData?.total === rowData?.payment_receiveed ? "#009A20" : "#1E40AF",
              width: 10,
              height: 10,
              borderRadius: "50%",
            }}
          ></div>
          <span
            style={{
              marginLeft: 8,
              fontWeight: "500",
              color:
                rowData?.total === rowData?.payment_receiveed ? "#009A20" : "#1E40AF",
              fontSize: "16px",
            }}
          >
            {rowData?.total === rowData?.payment_receiveed ? "Paid" : "Due"}
          </span>
        </div>
      ),
    }
    ,
    { title: "DUE DATE", dataIndex: "due_date", width: 150 },

    {
      title: "ACTION",
      filtering: false,
      width: 150,
      render: (rowData) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={Pencile}
            alt="Mail Sent"
            style={{ width: 25, height: 25 }}
            onClick={() => {
              if(rowData?.total === rowData?.payment_receiveed){
                toast.warning("After payment you can not edit invoice !")
                return
              }
              editInvoice(rowData);
            }}
          />

          <img
            src={Delete}
            alt="img"
            onClick={() => {
              //console.log("rowData", rowData);

              setShowDeletePopUp(rowData);
            }}
            style={{ width: 25, height: 25, marginLeft: 10 }}
          />
        </div>
      ),
    },
  ];

  const editInvoice = (data) => {
    setInvoiceData(data);
    setTimeout(() => {
      setEditModalOpen(true);
    }, 1000);
  };

  const downloadInvoice = async (data) => {
    const invoiceLink = `${BaseUrl}${Api.DOWNLOAD_INVOICE}/${data?.invoice_no}`;
    if (data?.invoice_status == "Drafts") {
      toast.warning("you can only show a bill after it has been sent by email")
      // alert("you can only show a bill after it has been sent by email");
    } else {
      try {
        const responseData = await axios.get(invoiceLink, {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Company-ID": userDetails.company_id,
          },
          responseType: "arraybuffer",
        });

        if (responseData?.data && responseData.data.byteLength > 0) {
          const blob = new Blob([responseData.data], {
            type: "application/pdf",
          });
          const url = URL.createObjectURL(blob);
          const newTab = window.open(url, "_blank");
          if (newTab) {
            newTab.focus();
          } else {
            toast.error("Unable to open PDF. Please check your browser's pop-up settings.",);
          }
        } else {
          toast.error("Invoice data is empty or not found.");
        }
      } catch (error) {
        console.error("API call failed:", error);
        toast.error("An error occurred. Please try again.");
      }
    }
  };

  const confirmDelete = async () => {
    const payload = { auto_generated_id: showDeletePopUp?.id }
    setLoading(true)
    try {
      let response = await callApi("/delete_invoice", "POST", payload, userDetails.token)
      if (response.success) {
        toast.success(response.mssg)
        dispatch(getAllInvoiceData());
        setShowDeletePopUp()
      } else {
        toast.error(response.mssg[0] || "Server Error")
      }
      setLoading(false)
      //console.log(response);

    } catch (error) {
      setLoading(false)
      toast.error(error.message || "server error")
      //console.log(error);
    }
  }

  return (
    <MainLayout>
      <div className="page-wrapper">
          {
            isDataLoading &&
            <Loader style={{height:"100"}} />
          }
        <div className="content">
          <div className="mainDivInvoice" >
            <h1 className="text-start d-flex pb-2" >
              Invoice
            </h1>
            <div className="mainDivInvoice2">
              <div className="card-containerInvoice">
                <div className="d-flex align-items-center justify-content-between">
                  <div
                    style={{
                      maxWidth: "200px",
                    }}
                  >
                    <div class="input-group mb-0">
                      <input id="search-query" class="form-control"
                        placeholder="Search..."
                        aria-label="Search" type="text"
                        name="query"
                        value={query}
                        onChange={handleInputChange} />
                      <span class="input-group-text"><i class="fa fa-search"></i></span></div>

                  </div>
                  <div className="">
                    <button className="btn btn-primary small d-flex align-items-center gap-1 " onClick={handleClick}>
                      <BsPlusCircle />
                      Create Invoice
                    </button>
                  </div>
                </div>

                <div
                  style={{
                    marginTop: "50px",
                    width: "100%",
                    maxHeight: "75vh",
                    overflowX: "auto",
                  }}
                >
                  <Table
                    dataSource={getAllinvoice?.filter((item) => {
                      if (query) {
                        return (
                          item.company_name.toLowerCase().includes(query.toLowerCase()) ||
                          item.customer_name.toLowerCase().includes(query.toLowerCase())
                        );
                      }
                      return item
                    })}
                    className="dotted-border-table"
                    columns={columns}
                    pagination={{ pageSize: 7, position: ["bottomRight"] }}
                    rowClassName={() => "custom-row"}
                    bordered={false}
                    // style={{ tableLayout: "auto" }}
                    tableLayout="fixed"
                    rowKey="key"
                    scroll={{ x: 1000 }} // Ensures proper scrolling behavior
                    locale={{
                      emptyText: (
                        <div className="custom-no-data">No Employee Data Found</div>
                      ),
                    }}
                  />
                </div>
              </div>
            </div>

            {/* <Outlet /> */}
            <EditInvoice
              open={editModalOpen}
              onClose={() => setEditModalOpen(false)}
              invoiceData={invoiceData}
            />
          </div>
        </div>
      </div>
      {
        showDeletePopUp?.id &&
        <div className="modal fade show none" id="delete_modal" aria-modal="true" role="dialog" style={{ display: "block" }}>
          <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content shadow">
              <div className="modal-body text-center">
                <span className="avatar avatar-xl bg-transparent-danger text-danger mb-3">
                  <i className="ti ti-trash-x fs-36"></i>
                </span>
                <h4 className="mb-1">Confirm Delete</h4>
                <p className="mb-3">{
                  // handleData?.message ? handleData?.message :
                  "You want to delete invoice, this can't be undone once you delete."
                }

                </p>
                <div className="d-flex justify-content-center">
                  <a onClick={() => {
                    setShowDeletePopUp({})
                  }
                    // handleData.onClose
                  } className="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
                  <a onClick={() => {
                    if (!isloading) {
                      confirmDelete()
                    }
                  }
                  } className="btn btn-danger">
                    {
                      isloading ? "Loading ... " : "Yes, Delete"
                    }

                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

    </MainLayout>
  );
};

export default Invoice;
